import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { BestellPdfVorschauDialogComponent } from './bestell-pdf-vorschau-dialog.component';

@NgModule({
    declarations: [BestellPdfVorschauDialogComponent],
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    exports: [BestellPdfVorschauDialogComponent],
})
export class BestellPdfVorschauDialogModule {}
